module.exports = "/_next/static/images/Mark_Clemens-2babbed970763b750618f2b5e168d684.webp";